export const formatDate = (date: Date): string => {
  const dateFormatter = new Intl.DateTimeFormat(
    [], {"year": "numeric", "month": "long", "day": "numeric", "weekday": "short"}
  )
  return dateFormatter.format(date)
}